//https://qaapiproteccioncelular.grupomok.com/api/CMS/ObtenerConfiguraciones/1
//let host =  "qaapiproteccioncelular.grupomok.com";
//let host = "preapiproteccioncelular.grupomok.com"
let host = process.env.REACT_APP_API //PRE
//let host = "apilandingsmx.grupomok.com"    //PRODUCCION
let gate = "api";

export const URL = `https://${host}/${gate}`;
